const formatDate = (date, format) => {
  let data = new Date(date);
  data = data.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
  data = data.replace(/\//g, '.');
  if (format === 'dd-mm') {
    return data.substring(0, data.length - 5);
  }
  return data;
};

/**
 * @param {string} date Ex.: DD/MM/YYYY
 * @return {boolean}
 * Recebe uma data no formato "DD/MM/YYYY" e compara com a data atual. Retorna true se a data informada estiver no futuro.
 */
function dateIsFuture(date) {
  if (!date) {
    return false;
  }

  const today = new Date();
  const parts = date.split('/');

  //* (ano + idade limite) - mês - dia
  const targetDate = new Date(parts[2], parts[1] - 1, parts[0]);

  return targetDate >= today;
}

/**
 * @param {string} date Ex.: DD/MM/YYYY
 * @param {number}
 * @return {boolean}
 * Recebe uma data no formato "DD/MM/YYYY";
 * Recebe um numero que representa os anos a serem calculados;
 * Retorna "true" se na data de hoje o tempo determinados em anos já passou. Retorna false se ainda não passaram o numero de anos estabelecidos.
 */
function dateIsOlderThan(date, limit = 18) {
  if (!date) {
    return false;
  }

  const today = new Date();
  const parts = date.split('/');

  //* (ano + idade limite) - mês - dia
  const targetDate = new Date(Number(parts[2]) + limit, parts[1] - 1, parts[0]);

  return targetDate <= today;
}

/**
 * @param {string} date Ex.: YYYY-MM-DD
 * @return {string} date Ex.: DD/MM/YYYY
 * Recebe uma data no formato "YYYY-MM-DD" e retorna uma data no formato "DD/MM/YYYY";
 */
function toDashMode(date) {
  if (!date) {
    return '00/00/0000';
  }
  return date
    .split('-')
    .reverse()
    .join('/');
}

/**
 * @param {string} date Ex.: DD/MM/YYYY
 * @return {string} date Ex.: YYYY-MM-DD
 * Recebe uma data no formato "DD/MM/YYYY" e retorna uma data no formato "YYYY-MM-DD";
 */
function toForwardSlashMode(date) {
  if (!date) {
    return '00-00-0000';
  }
  return date
    .split('/')
    .reverse()
    .join('-');
}

export {
  formatDate,
  dateIsFuture,
  dateIsOlderThan,
  toDashMode,
  toForwardSlashMode,
};
